// src/components/contact/ContactHero.jsx
import { motion } from "framer-motion";
import contactIllustration from "../../assets/images/contact/contact.svg"; // Add a suitable SVG illustration

const ContactHero = () => {
  return (
    <section className="bg-gradient-to-br from-[#F0F9FF] via-white to-[#EDEBFF] py-20 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 items-center gap-12">
        {/* Left: Text Content */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="z-10"
        >
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-primary mb-6 leading-tight">
            Let’s Connect & Create Impact Together
          </h1>
          <p className="text-lg text-gray-700 mb-6 leading-relaxed">
            Whether you’re a non-profit, corporate, or changemaker, we’re here to collaborate. Reach out for partnerships, project support, or simply to say hello!
          </p>

          <a
            href="#contact-form"
            className="inline-block bg-primary text-white px-6 py-3 rounded-full font-medium hover:bg-secondary transition shadow-md"
          >
            Get in Touch
          </a>
        </motion.div>

        {/* Right: Illustration */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9 }}
          className="flex justify-center"
        >
          <img
            src={contactIllustration}
            alt="Contact Illustration"
            className="max-w-md w-full drop-shadow-lg"
          />
        </motion.div>
      </div>

      {/* Optional subtle background icon */}
      <div className="absolute bottom-0 right-0 opacity-10 pointer-events-none">
        <img
          src="/assets/images/fingerprint-bg.svg"
          alt="Decorative Pattern"
          className="w-[300px] hidden md:block"
        />
      </div>
    </section>
  );
};

export default ContactHero;
